import React from "react"
import { useSelector } from "react-redux"

import AemGrid from "@/components/AemGrid"
import { selectPdpState } from "@/store/features/pdpSlice"

const ProductExf = () => {
  const { teaserContent = [] } = useSelector(selectPdpState)

  return teaserContent.length
    ? teaserContent.map((item, index) => (
        <div className="exfpdp" key={`${item["title"]}-${index}`}>
          <div className="xfpage">
            <AemGrid data={item} count={0} />
          </div>
        </div>
      ))
    : null
}

export default ProductExf
